import postal from 'postal';
import { roadblockMessageName } from '../../../../utils/roadblocks';

const createReactClass = require('create-react-class');

/*
  Embed an instance of this component on a page that has mobile-roadblocked links or modals.
  Branch will be watching for us pushing the metadata that triggers a Journey show.
*/
const MobileRoadblock = createReactClass({
  componentDidMount() {
    if (this.props.mobileBrowser && branch) {
      const branchOptions = {
        disable_entry_animation: true,
        disable_exit_animation: true
      };
      branch.init(this.props.branchKey, branchOptions);
    }

    const messagingChannelName = 'explore_messagingChannel';
    this.messagingChannel = postal.channel(messagingChannelName);
    this.listener = this.messagingChannel.subscribe(roadblockMessageName, this.handleRoadblock);
  },
  componentWillUnmount() {
    if (this.listener) {
      postal.unsubscribe(this.listener);
    }
  },
  afterRoadblock(data) {
    if (typeof data.afterRoadblock === 'function') {
      data.afterRoadblock();
    } else {
      this.navigateToAfterRoadblock(data);
    }
  },
  navigateToAfterRoadblock(data) {
    if (data.openInNewTab) {
      window.open(data.afterRoadblock, '_blank');
    } else {
      window.location = data.afterRoadblock;
    }
  },
  handleRoadblock(data) {
    if (!data.currentUser) {
      const ref = data.atRef ? `ref=${data.atRef}&` : '';
      const returnTo = `returnTo=${encodeURIComponent(data.returnToUrl)}`;
      window.location = window.checkLinkAndAppendLanguage(`/signup?${ref}${returnTo}`);
      return;
    }

    // Proceed directly to next step if not mobile
    if (!this.props.mobileBrowser) {
      this.afterRoadblock(data);
      return;
    }

    // Only a subset of roadblocks apply to signed-in-user
    const signedInRoadblocks = ['trail_header_map', 'trail_explore', 'trail_print', 'park_print', 'create_map', 'print_maps'];
    // Show only every third time
    const signedInRoadblockEvery = 3;
    if (window && window.localStorage && signedInRoadblocks.includes(data.event)) {
      const authRoadblockCount = (window.localStorage.getItem('authRoadblockCount') + 1) % signedInRoadblockEvery;
      window.localStorage.setItem('authRoadblockCount', authRoadblockCount);
      if (authRoadblockCount + 1 === signedInRoadblockEvery) {
        if (this.afterBranchListener) {
          branch.removeListener(this.afterBranchListener);
        }
        this.afterBranchListener = event => {
          if (event === 'willNotShowJourney' || event === 'didCloseJourney') {
            this.afterRoadblock(data);
          }
        };
        branch.addListener(this.afterBranchListener);
        branch.track('pageview', {
          AUTHENTICATED: 'true',
          SHOW_JOURNEY: 'MOBILE_ROADBLOCK'
        });
        return;
      }
    }
    // No Journey shown, so proceed directly to next step
    this.afterRoadblock(data);
  },
  render() {
    return null;
  }
});

export { MobileRoadblock };
